import { compose, prop, map, filter, propEq, propOr } from 'ramda';
import { ROLES } from '../../lib/rights';

export const getOfferIdsByUserTeam = (userTeam, isQa) => compose(
  map(prop('offerId')),
  filter(role => prop('offerId', role) && (!isQa || propEq(ROLES.qa, 'role', role)))
)(propOr([], 'roles', userTeam));